import { DataLayerTracker } from '../DataLayer/tracker'
import { EnhancedEcommerceMapper } from './mapper'

export class EnhancedEcommerceTracker extends DataLayerTracker {
  _auto

  constructor() {
    super()

    this._auto = null
  }

  _setAuto(state) {
    if (state?.product && state?.ordine) {
      this._auto = EnhancedEcommerceMapper.mapProduct(state)
    }
  }

  pushAdd(state, list) {
    return new Promise(resolve => {
      if (!this._auto && !state) {
        resolve()

        return
      }

      this._setAuto(state)

      const data = EnhancedEcommerceMapper.mapAdd(
        { ...this._auto },
        list || null
      )
      DataLayerTracker.push(data)

      resolve()
    })
  }

  pushCheckout(state, step) {
    return new Promise(resolve => {
      if ((!this._auto && !state) || !step) {
        resolve()

        return
      }

      this._setAuto(state)

      const data = EnhancedEcommerceMapper.mapCheckout({ ...this._auto }, step)
      DataLayerTracker.push(data)

      resolve()
    })
  }

  pushCheckoutOption(step, option) {
    return new Promise(resolve => {
      if (!step || undefined === option) {
        resolve()

        return
      }

      const data = EnhancedEcommerceMapper.mapCheckoutOption(step, option)
      DataLayerTracker.push(data)

      resolve()
    })
  }

  pushPurchase(state) {
    return new Promise(resolve => {
      if (!this._auto && !state) {
        resolve()

        return
      }

      this._setAuto(state)

      const data = EnhancedEcommerceMapper.mapPurchase(
        EnhancedEcommerceMapper.mapOrder(state),
        this._auto
      )
      DataLayerTracker.push(data)

      resolve()
    })
  }
}

export const enhancedEcommerceTracker = new EnhancedEcommerceTracker()
